module.exports = __webpack_public_path__ + "img/solution_banner.bdb4ec98.jpg";